// import React from "react";
// import Carousel from "react-bootstrap/Carousel";
// import buildingTemplates from "../utils/buildingTemplates";

// function ImageCarousel({ selectedTemplate, onTemplateSelect }) {
//   const findTemplateIndex = () => buildingTemplates.findIndex(template => template.id === selectedTemplate);

//   return (
//     <div className="template-gallery">
//       <Carousel
//         activeIndex={findTemplateIndex()}
//         onSelect={(selectedIndex, e) => onTemplateSelect(buildingTemplates[selectedIndex].id)}
//         interval={null}
//       >
//         {buildingTemplates.map((template) => (
//           <Carousel.Item key={template.id}>
//             <img
//               className="d-block w-100"
//               src={template.image}
//               alt={template.name}
//             />
//             <Carousel.Caption>
//               <p>{template.name}</p>
//             </Carousel.Caption>
//           </Carousel.Item>
//         ))}
//       </Carousel>
//     </div>
//   );
// }

// export default ImageCarousel;


import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import buildingTemplates from "../utils/buildingTemplates";

function ImageCarousel({ selectedTemplate, onTemplateSelect }) {
  const [isEnlarged, setIsEnlarged] = useState(false);

  const findTemplateIndex = () => buildingTemplates.findIndex(template => template.id === selectedTemplate);

  const toggleEnlarged = (e) => {
    e.stopPropagation(); // מונע מהאירוע להתפשט להורה
    setIsEnlarged(!isEnlarged);
  };

  return (
    <>
      <div 
        className={`template-gallery ${isEnlarged ? 'enlarged' : ''}`}
        onClick={toggleEnlarged}
      >
        <Carousel
          activeIndex={findTemplateIndex()}
          onSelect={(selectedIndex, e) => {
            e.stopPropagation(); // מונע מהקרוסלה להתחלף בלחיצה
            onTemplateSelect(buildingTemplates[selectedIndex].id);
          }}
          interval={null}
        >
          {buildingTemplates.map((template) => (
            <Carousel.Item key={template.id}>
              <img
                className="d-block w-100"
                src={template.image}
                alt={template.name}
              />
              <Carousel.Caption>
                <p>{template.name}</p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      {isEnlarged && (
        <div 
          className="overlay"
          onClick={toggleEnlarged}
        />
      )}

      <style>
        {`
          .template-gallery {
            position: relative;
            transition: all 0.3s ease;
            z-index: 1;
          }

          .template-gallery.enlarged {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 90vw;
            max-width: 1200px;
            height: auto;
            z-index: 1000;
          }

          .overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
            z-index: 999;
          }

          /* שמירה על יחס רוחב-גובה תקין */
          .template-gallery.enlarged .carousel,
          .template-gallery.enlarged .carousel-item {
            width: 100%;
            height: 80vh;
          }

          .template-gallery.enlarged img {
            object-fit: contain;
            height: 100%;
          }

          /* סגנונות נוספים לקרוסלה במצב מוגדל */
          .template-gallery.enlarged .carousel-caption {
            background: rgba(0, 0, 0, 0.5);
            padding: 1rem;
            border-radius: 5px;
          }

          /* אנימציה חלקה */
          .template-gallery, .overlay {
            transition: all 0.3s ease-in-out;
          }
        `}
      </style>
    </>
  );
}

export default ImageCarousel;